import color from "../../constants/color";

const style = {
  gridText: {
    fontSize: "22px",
    fontWeight: "600",
  },
  mainContainer: {},
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px: 2,
    borderRadius: "20px",
    height: "fit-content",
    display: "flex",
    flexWrap: "wrap",
  },
  modalGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    gap: "12px",
  },
  heading: {
    width: { xs: "30%", md: "20%", lg: "20%" },
  },
  head: {
    fontSize: "20px",
    fontWeight: "600",
    color: color.text,
    whiteSpace: "nowrap",
  },
  noShadow: {
    mt: 2,
  },
  tableHead: {
    fontSize: "14px",
    fontWeight: "600",
    color: color.text,
  },
  tableData: {
    fontSize: "14px",
    color: color.text,
  },
  tableActiondata: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    px: 3,
    mr: 1,
  },
  dropdown: {
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
    {
      padding: "8.5px 14px",
    },
    width: "100%",
    fontSize: "14px",
    fontWeight: "400",
    mt: 1,
  },
  dropDownMenu: {
    fontWeight: 400,
    fontSize: "12px",
  },
  box2: {
    width: "100%",
    maxWidth: "280px",
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: 1,
  },
};

export default style;
